<template>
  <div class="home-banner">
    <div class="banner-item left-banner" @click="goTrainingNotice">
      <el-image
        :src="require('@/assets/home/peixuntongzhi.png')"
        fit="cover"
        style="width: 100%; height: 100%;"
      ></el-image>
    </div>
    <div class="banner-item right-banner" @click="goInfoNews">
      <el-image
        :src="require('@/assets/home/xinxizixun.png')"
        fit="cover"
        style="width: 100%; height: 100%;"
      ></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeBanner",
  props: {
    bannerList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    goTrainingNotice() {
      this.$emit("go-training-notice");
    },
    goInfoNews() {
      this.$emit("go-info-news");
    }
  }
};
</script>

<style scoped lang="scss">
.home-banner {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  height: 200px;

  .banner-item {
    width: 590px;
    height: 100%;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      opacity: 0.95;
    }
  }
}
</style>
